import { Box, Stack } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import {
  EducationCategories,
  EducationTagToName,
  FontStyle,
  JobDisplays,
} from "../../constants";

const EdCategoryButton = ({ categoryIdx, setCategoryIdx, idx }) => {
  const buttonRef = React.useRef(null);
  const selected = categoryIdx === idx;
  const [tempBg, setTempBg] = React.useState(null);
  return (
    <Stack
      ref={buttonRef}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        cursor: "pointer",
        userSelect: "none",
        py: JobDisplays.padding,
        width: "100%",
        maxWidth: "100%",
        transition: "background-color 0.1s ease",
        "&:hover": {
          //   ...(!selected && { backgroundColor: Color.primaryLight }),
        },
        // ...(tempBg && { backgroundColor: tempBg }),
      }}
      onClick={() => {
        setCategoryIdx(idx);
        setTempBg("#aaa8");
        setTimeout(() => {
          setTempBg(null);
        }, 150);
      }}>
      {EducationTagToName[EducationCategories[idx]]}
    </Stack>
  );
};

const menuPadding = 16;
const underlinePadding = 0;
const EducationCategorySelector = ({ categoryIdx, setCategoryIdx }) => {
  const [underlineData, setUnderlineData] = React.useState({
    width: 0,
    left: 0,
  });
  const [menuWidth, setMenuWidth] = React.useState(0);
  const handleWidth = useCallback((node) => {
    if (!node) return;
    setMenuWidth(node.clientWidth);
    const resizeObserver = new ResizeObserver(() => {
      if (!node) return;
      setMenuWidth(node.clientWidth);
    });
    resizeObserver.observe(node);
  }, []);
  useEffect(() => {
    if (menuWidth === 0) return;
    setUnderlineData({
      width:
        (menuWidth - menuPadding * 2) / EducationCategories.length -
        underlinePadding * 2,
      left:
        ((menuWidth - menuPadding * 2) / EducationCategories.length) *
          categoryIdx +
        menuPadding +
        underlinePadding,
    });
  }, [menuWidth, categoryIdx]);

  return (
    <Stack
      direction="row"
      //   spacing={2}
      ref={handleWidth}
      sx={{
        width: "100%",
        borderRadius: JobDisplays.borderRadius,
        backgroundColor: JobDisplays.backgroundColor,
        boxShadow: JobDisplays.boxShadow,
        px: `${menuPadding}px`,
        py: 0,
        zIndex: 1,
        ...FontStyle.headingBody,
        position: "relative",
        textAlign: "center",
      }}>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: underlineData.left,
          width: underlineData.width,
          height: "6px",
          backgroundColor: "#12aafd",
          transition: "all 0.3s ease",
        }}
      />
      {EducationCategories.map((category, idx) => {
        return (
          <EdCategoryButton
            categoryIdx={categoryIdx}
            setCategoryIdx={setCategoryIdx}
            idx={idx}
            setUnderlineData={setUnderlineData}
            key={idx}
          />
        );
      })}
    </Stack>
  );
};

export default EducationCategorySelector;
